// NOTE: should match the bootstrap grid (styles/core-scss/foundation/energiedirect/_grid.scss)
export const BREAKPOINTS = {
  XSmall: '(max-width: 539px)',
  Small: '(min-width: 540px) and (max-width: 767px)',
  Medium: '(min-width: 768px) and (max-width: 959px)',
  Large: '(min-width: 960px) and (max-width: 1440px)',
  XLarge: '(min-width: 1441px)',
};
